<template>
    <div>
        <div class="start-destination-class" style="border-bottom:1px solid #ECEFF3;">
            <div class="filghts-line-text"><span>退改签信息</span></div>
        </div>
       <div class="border-div" style="margin-top:2em;">
        <!--<div class="head-title" >
                <img src="../../../assets/flights/i_icon_explain_32px_@2x.png"/>
                <div>小贴士</div>    
            </div>
            <div class="flex-start">
                <div class="blue-font">证件限制：</div>
                <div>此航班仅支持身份证</div>
            </div> -->
        </div>
        <div class="border-div">
            <div class="head-title">
                <img src="../../../assets/flights/i_icon_explain_32px_@2x.png"/>
                <div>成人退改签说明</div>    
            </div>
            <div class="t-table" style="margin-top:20px;">
                <div>
                    <div>托运行李</div>
                    <div><div>无免费托运行李</div></div>
                </div>
                <div>
                    <div>手提行李额</div>
                    <div><div>1件，10KG，体积不超过20x40x55CM</div></div>
                </div>
                <!-- <div>
                    <div>舱位代码</div>
                    <div><div>T</div></div>
                </div> -->
                <div>
                    <div>退票规则</div>
                    <div>
                        <div>起飞前30天（720小时）（含）之前，收取30%，</div>
                        <div>起飞前30天（720小时）（不含）至14天（336小时）（含）,收取60%,</div>
                        <div>起飞前14天（336小时）（不含）至4小时（含）,收取90%，</div>
                        <div>起飞前4小时（不含）至航班起飞后，收取100%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    }
}
</script>
<style scoped>
    .start-destination-class{
        width:100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 199;
    }
    .filghts-line-text{
        box-sizing: border-box;
        padding:0.25em 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: #2E3033;
    }
    .border-div{
        width:100vw;
        padding:15px;
        padding-bottom:0px; 
        box-sizing: border-box;
    }
    .head-title{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 15px;
        font-weight: bold;
        color: #2E3033;
    }
    .head-title > img{
        height: 16px;
        width:16px;
        margin-right:5px;
    }
    .t-table{
        width:calc( 100vw - 30px );
        border-radius: 4px;
        border: 1px solid #CFD6E6;
    }
    .t-table > div {
        border-bottom:1px solid #CFD6E6;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .t-table > div:last-child {
        border-bottom:0;
    }
    .t-table > div > div:nth-child(1) {
        width:6em;
        box-sizing:border-box;
        height: 100%;
        display: flex;
        justify-content:center;
        align-items: center;
        font-size: 14px;
        color: #737780;
    }
    .t-table > div > div:nth-child(2) {
        width: calc( 100% - 6em );
        box-sizing:border-box;
        border-left:1px solid #CFD6E6;
        padding:15px;
        font-size: 14px;
        color: #2E3033;
    }
    .flex-start{
        display: flex;
        justify-content:flex-start;
        font-size: 14px;
        font-weight: 500;
        color: #5C5F66;
        margin-top:15px;
    }
    .blue-font{
        color: #3377FF;
    }
</style>